export class TechincalSlate {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "TechincalSlate";
    this.scene = "TechincalSlate";
    this.data = [];
    this.page = 1403;
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    await this.updateVizPage({ page: this.page, data: xml });
    this.sendPreview("page:read " + this.page);
    this.comms(options);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.sendAnimateOff({ page: this.page });
    this.onAir = false;
  }
}
